/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SharedserviceMelcoModelsAddAlphabetCollection,
    SharedserviceMelcoModelsAddAlphabetCollectionFromJSON,
    SharedserviceMelcoModelsAddAlphabetCollectionToJSON,
    SharedserviceMelcoModelsAlphabetCollection,
    SharedserviceMelcoModelsAlphabetCollectionFromJSON,
    SharedserviceMelcoModelsAlphabetCollectionToJSON,
    SharedserviceMelcoModelsAlphabetCollectionReferences,
    SharedserviceMelcoModelsAlphabetCollectionReferencesFromJSON,
    SharedserviceMelcoModelsAlphabetCollectionReferencesToJSON,
    SharedserviceMelcoModelsError,
    SharedserviceMelcoModelsErrorFromJSON,
    SharedserviceMelcoModelsErrorToJSON,
    SharedserviceMelcoModelsUpdateAlphabetCollection,
    SharedserviceMelcoModelsUpdateAlphabetCollectionFromJSON,
    SharedserviceMelcoModelsUpdateAlphabetCollectionToJSON,
} from '../models';

export interface AlphabetCollectionsApiAlphabetCollectionsReferencesRequest {
    id: string;
}

export interface AlphabetCollectionsApiUserAlphabetCollectionUpdateRequest {
    id: string;
    sharedserviceMelcoModelsUpdateAlphabetCollection?: SharedserviceMelcoModelsUpdateAlphabetCollection;
}

export interface AlphabetCollectionsApiUserAlphabetCollectionsCreateRequest {
    sharedserviceMelcoModelsAddAlphabetCollection?: SharedserviceMelcoModelsAddAlphabetCollection;
}

export interface AlphabetCollectionsApiUserAlphabetCollectionsDeleteRequest {
    id: string;
    force?: boolean;
}

export interface AlphabetCollectionsApiUserAlphabetCollectionsDuplicateRequest {
    id: string;
}

export interface AlphabetCollectionsApiUserAlphabetCollectionsGetDefRequest {
    id: string;
    publishState?: string;
}

/**
 * 
 */
export class AlphabetCollectionsApi extends runtime.BaseAPI {

    /**
     */
    async alphabetCollectionsReferencesRaw(requestParameters: AlphabetCollectionsApiAlphabetCollectionsReferencesRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsAlphabetCollectionReferences>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling alphabetCollectionsReferences.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/collections/{Id}/references`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsAlphabetCollectionReferencesFromJSON(jsonValue));
    }

    /**
     */
    async alphabetCollectionsReferences(requestParameters: AlphabetCollectionsApiAlphabetCollectionsReferencesRequest): Promise<SharedserviceMelcoModelsAlphabetCollectionReferences> {
        const response = await this.alphabetCollectionsReferencesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetCollectionUpdateRaw(requestParameters: AlphabetCollectionsApiUserAlphabetCollectionUpdateRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsAlphabetCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetCollectionUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/alphabets/collections/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoModelsUpdateAlphabetCollectionToJSON(requestParameters.sharedserviceMelcoModelsUpdateAlphabetCollection),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsAlphabetCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetCollectionUpdate(requestParameters: AlphabetCollectionsApiUserAlphabetCollectionUpdateRequest): Promise<SharedserviceMelcoModelsAlphabetCollection> {
        const response = await this.userAlphabetCollectionUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetCollectionsCreateRaw(requestParameters: AlphabetCollectionsApiUserAlphabetCollectionsCreateRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsAlphabetCollection>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/alphabets/collections`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoModelsAddAlphabetCollectionToJSON(requestParameters.sharedserviceMelcoModelsAddAlphabetCollection),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsAlphabetCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetCollectionsCreate(requestParameters: AlphabetCollectionsApiUserAlphabetCollectionsCreateRequest): Promise<SharedserviceMelcoModelsAlphabetCollection> {
        const response = await this.userAlphabetCollectionsCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetCollectionsDeleteRaw(requestParameters: AlphabetCollectionsApiUserAlphabetCollectionsDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetCollectionsDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['Force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/collections/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userAlphabetCollectionsDelete(requestParameters: AlphabetCollectionsApiUserAlphabetCollectionsDeleteRequest): Promise<void> {
        await this.userAlphabetCollectionsDeleteRaw(requestParameters);
    }

    /**
     */
    async userAlphabetCollectionsDuplicateRaw(requestParameters: AlphabetCollectionsApiUserAlphabetCollectionsDuplicateRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsAlphabetCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetCollectionsDuplicate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/collections/{Id}/duplicate`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsAlphabetCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetCollectionsDuplicate(requestParameters: AlphabetCollectionsApiUserAlphabetCollectionsDuplicateRequest): Promise<SharedserviceMelcoModelsAlphabetCollection> {
        const response = await this.userAlphabetCollectionsDuplicateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userAlphabetCollectionsGetDefRaw(requestParameters: AlphabetCollectionsApiUserAlphabetCollectionsGetDefRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsAlphabetCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userAlphabetCollectionsGetDef.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/alphabets/collections/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsAlphabetCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userAlphabetCollectionsGetDef(requestParameters: AlphabetCollectionsApiUserAlphabetCollectionsGetDefRequest): Promise<SharedserviceMelcoModelsAlphabetCollection> {
        const response = await this.userAlphabetCollectionsGetDefRaw(requestParameters);
        return await response.value();
    }

}
